import { render, staticRenderFns } from "./newsB.vue?vue&type=template&id=73c41616&scoped=true"
import script from "./newsB.vue?vue&type=script&lang=js"
export * from "./newsB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c41616",
  null
  
)

export default component.exports